import { MessageSeverity } from "@dcc/shared/domain";
import { PlatformAlert, PlatformApplicationAlert } from "./system-message.model";

export function getPlatformAlert(applicationMessages: PlatformApplicationAlert[]): PlatformAlert | undefined {
    return applicationMessages.find((message) => message.applicationId === undefined);
}

export function getLocalizedMessage(locale: string | null | undefined, alert: PlatformApplicationAlert | PlatformAlert): string {
    switch (locale) {
        case "en": {
            return alert.english;
        }
        case "de": {
            return alert.german && alert.german !== "" ? alert.german : alert.english;
        }
        case "es": {
            return alert.spanish && alert.spanish !== "" ? alert.spanish : alert.english;
        }
        case "ja": {
            return alert.japanese && alert.japanese !== "" ? alert.japanese : alert.english;
        }
        case "zh-cn": {
            return alert.chineseSimplified && alert.chineseSimplified !== "" ? alert.chineseSimplified : alert.english;
        }
        case "zh-tw": {
            return alert.chineseTraditional && alert.chineseTraditional !== "" ? alert.chineseTraditional : alert.english;
        }

        default: {
            return alert.english;
        }
    }
}

export function mapSeverityToAppearance(alert: PlatformAlert | null) {
    if (!alert) return "info";

    switch (alert.severity) {
        case MessageSeverity.high:
            return "warning";
        case MessageSeverity.critical:
            return "error";
        case MessageSeverity.normal:
        default:
            return "info";
    }
}
